//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BUILDING_RANK_MAP } from '@/constant'
import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    props: {
        aqr: Object
    },
    computed: {
        headimg () {
            const { building } = this.aqr
            if (building && building.cover_photo_url) {
                return handleImgSize(building.cover_photo_url, 500, 332)
            }
        },
        rank_desc () {
            const { building_ranking }  = this.aqr.building
            const rank_type = building_ranking && BUILDING_RANK_MAP[building_ranking.ranking_type]
            if (rank_type) {
                return `入选${building_ranking.zone}${rank_type}第${building_ranking.ranking_order}名`
            }
        }
    },
    methods: {
        openBuilding () {
            wx.navigateTo({
                url: `/building?building_id=${this.aqr.building.id}&status=${this.aqr.building.status_name}`
            })
            this.$sendCtmEvtLog(`微聊页面推荐楼盘弹窗--楼盘点击`)
        },
        changeBuilding () {
            this.$emit('changeBuilding')
            this.$sendCtmEvtLog(`微聊页面推荐楼盘弹窗--换个楼盘`)
        },
        chat () {
            this.hide()
            this.$sendCtmEvtLog(`微聊页面推荐楼盘弹窗--继续聊`)
        },
        hide () {
            this.$emit('hide')
        }
    }
}
